export const AUTH_ROUTE_PATHS = {
  signIn: '/sign-in',
  signInReset: '/sign-in/reset',
  signInResetVerify: '/sign-in/reset/verify',
  signInRestore: '/sign-in/restore',
  signInRestoreVerify: '/sign-in/restore/verify',
  signUp: '/sign-up',
  acceptInvitation: '/accept-invitation',
  authCallback: '/auth/callback',
  resetPassword: '/reset-password',
  resetPasswordConfirm: '/reset-password/:token',
  verifyEmail: '/verify-email/:token',
} as const;
